import React, { useState } from "react";
import { Loader2, Upload, X } from "lucide-react";
import { apiUploadFile } from "../../../api";

export const inputCls = "w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none focus:ring-2 focus:ring-blue-500";

export const Labeled = ({ label, hint, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
    {children}
    {hint && <span className="block text-xs text-slate-400">{hint}</span>}
  </label>
);

export const Card = ({ title, children, action }) => (
  <section className="space-y-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    {(title || action) && (
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-semibold text-slate-900">{title}</h3>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const ImageUpload = ({ value, onChange, label = "Subir imagen", testid, square }) => {
  const [pct, setPct] = useState(null);
  const pick = async (file) => {
    if (!file) return;
    setPct(0);
    try {
      const { url } = await apiUploadFile(file, setPct);
      onChange(url);
    } catch {
      alert("No se pudo subir la imagen");
    } finally {
      setPct(null);
    }
  };
  return (
    <div className="flex items-center gap-3">
      {value ? (
        <div className={`relative overflow-hidden rounded-xl border bg-slate-50 ${square ? "h-20 w-20" : "h-16 w-28"}`}>
          <img src={value} alt="" className="h-full w-full object-contain" />
          <button type="button" onClick={() => onChange("")} className="absolute right-1 top-1 rounded-full bg-black/60 p-0.5 text-white" data-testid={testid ? `${testid}-remove` : undefined}>
            <X className="h-3 w-3" />
          </button>
        </div>
      ) : null}
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-xl border border-dashed border-slate-300 px-3.5 py-2.5 text-sm text-slate-600 hover:border-blue-400" data-testid={testid}>
        {pct !== null ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {pct !== null ? `${pct}%` : label}
        <input type="file" accept="image/*" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
      </label>
    </div>
  );
};
